import { StatesColors } from '@arredo/reactjs-ui';

export const columns = [
  {
    field: "displayTerminal",
    header: "Terminal",
    sizes: { xs: 2 },
  },
  {
    field: "created",
    header: "Creado",
    type: "date24",
  },
  {
    field: "state",
    header: "Estado",
    type: "chip",
    sx: (row) => StatesColors[row.state],
    translate: (state) => statesDisplay[state],
  },
  {
    field: "userEmail",
    header: "Usuario",
    sizes: { xs: 3 },
  },
];

export const title = "Cierres de Lote";

export const statesDisplay = {
  Initialized: "Inicializado",
  Processing: "Procesando",
  Approved: "Confirmado",
  Rejected: "Rechazado",
  Error: "Error",
};
